module.exports = __webpack_public_path__ + "img/04.803e6adc.jpg";